// extracted by mini-css-extract-plugin
export default {"loadcontainer":"SignUp_loadcontainer__ig2nQ","container":"SignUp_container__iie1G","innerBox":"SignUp_innerBox__WXK7t","footer":"SignUp_footer__j1C+s","error":"SignUp_error__FNTrg"};